class WaiverModalController {
    constructor(toastr, UserDetailsApi, WaiverServiceApi, moment) {
        this.$onInit = () => {
            this.params = this.resolve;
            this.selectedItems = this.params.selectedItems;
            this.waiverWithNotes = this.params.waiverWithNotes;
            this.UserDetailsApi.get().then(response => {
                this.user = response.data;
                this.renderWaiverInputs(this.user, this.waiverWithNotes);
            });
        };
        this.renderWaiverInputs = (user, waiverWithNotes) => {
            let waiver = waiverWithNotes.Waiver;
            let isSupporting = user.IsSupport;
            this.inputDisabled = false;
            // Render for Tester
            let requestNote = waiverWithNotes.RequestNote;
            let hasWaiver = waiverWithNotes.HasWaiver;
            this.hasWaiver = hasWaiver;
            this.waiverId = hasWaiver ? waiverWithNotes.Waiver.Id : 0;
            // No waiver
            if (!hasWaiver) {
                this.requestWaiver = !isSupporting;
                this.decideWaiver = isSupporting;
                this.caption = isSupporting
                    ? 'Grant/Deny Waiver'
                    : 'Request Waiver';
                this.placeholder = isSupporting
                    ? 'Please provide a reason for granting/denying a waiver on this test'
                    : 'Please provide a reason for requesting a waiver on this test';
            }
            // Outstanding
            if (hasWaiver && waiver.WaiverStatus === WaiverStatus.Outstanding) {
                let timeAgo = this.getFromNowString(waiver.RequestedOn);
                this.status = `Requested ${timeAgo}: ${requestNote}`;
                this.requestWaiver = false;
                this.decideWaiver = isSupporting;
                this.caption = isSupporting
                    ? 'Grant/Deny Waiver'
                    : 'Waiver Requested';
                this.reason = '';
                this.placeholder = isSupporting
                    ? 'Please provide a reason for granting/denying a waiver on this test'
                    : '';
                this.inputDisabled = !isSupporting;
            }
            // Denied
            if (hasWaiver && waiver.WaiverStatus === WaiverStatus.Denied) {
                this.inputDisabled = !isSupporting;
                this.requestWaiver = false;
                this.decideWaiver = isSupporting;
                let timeAgo = this.getFromNowString(waiver.DecidedOn);
                this.status = `Denied ${timeAgo}`;
                this.caption = 'Waiver Request Denied';
                this.reason = waiverWithNotes.ResponseNote;
            }
            // Approved
            if (hasWaiver && waiver.WaiverStatus === WaiverStatus.Approved) {
                this.inputDisabled = !isSupporting;
                this.requestWaiver = false;
                this.decideWaiver = isSupporting;
                let timeAgo = this.getFromNowString(waiver.DecidedOn);
                this.status = `Approved ${timeAgo}`;
                this.caption = 'Waiver Request Approved';
                this.reason = waiverWithNotes.ResponseNote;
            }
        };
        this.getFromNowString = (utcTime) => {
            let utc = this.moment.utc(utcTime);
            let local = this.moment(utc).local();
            return this.moment(local).fromNow();
        };
        this.createWaiverDecision = (approved, reason) => {
            let waiverDecision = {
                TesterId: this.selectedItems.selectedTester.Id,
                ProjectIterationId: this.selectedItems.projectIterationId,
                SimId: this.selectedItems.selectedSim.Id,
                SuiteId: this.selectedItems.selectedSuite.Id,
                TestId: this.selectedItems.selectedTest.Id,
                DecidedBy: this.user.Id,
                Decision: approved,
                Reason: reason
            };
            return waiverDecision;
        };
        this.updateWaiverAndReturn = (approved, reason) => {
            this.status = 'Updating waiver decision...';
            let msg = approved ? 'Approved' : 'Denied';
            if (_.isEmpty(reason)) {
                this.toastr.error('You must enter a reason for the waiver');
                return;
            }
            let waiverDecision = this.createWaiverDecision(approved, reason);
            this.WaiverServiceApi.getDecidedWaiver(waiverDecision).then(response => {
                let waiverWithNotes = response.data;
                if (!waiverWithNotes.HasWaiver) {
                    this.toastr.error(waiverWithNotes.RejectReason);
                }
                else {
                    this.toastr.info('Waiver ' + msg);
                    this.Close(waiverWithNotes);
                }
            });
        };
        this.request = (reason) => {
            if (_.isEmpty(reason)) {
                this.toastr.error('You must enter a reason for the waiver');
                return;
            }
            let saveNoteRequest = {
                NoteText: reason,
                UserId: this.selectedItems.selectedTester.Id,
                ProjectIterationId: this.selectedItems.projectIterationId,
                SimId: this.selectedItems.selectedSim.Id,
                SuiteId: this.selectedItems.selectedSuite.Id,
                TestId: this.selectedItems.selectedTest.Id,
                CreatedBy: (this.user.IsProjectTester || this.user.IsSupport) ? this.user.Id : this.selectedItems.selectedTester.Id,
                TraceUid: '',
                NotifySupport: true
            };
            this.WaiverServiceApi.requestWaiver(saveNoteRequest).then(response => {
                if (!_.isNil(response) && !_.isNil(response.data)) {
                    let waiverWithNotes = response.data;
                    if (!waiverWithNotes.HasWaiver) {
                        this.toastr.error(waiverWithNotes.RejectReason);
                    }
                    else {
                        this.toastr.info('Waiver requested');
                        this.Close(waiverWithNotes);
                    }
                }
            });
        };
        this.grant = (reason) => this.updateWaiverAndReturn(true, reason);
        this.deny = (reason) => this.updateWaiverAndReturn(false, reason);
        this.removeWaiver = (waiverId) => {
            this.WaiverServiceApi.removeWaiver(waiverId, this.waiverWithNotes.Waiver.TestId).then(response => {
                let waiverWithNotes = {
                    HasWaiver: false
                };
                if (response.data) {
                    this.toastr.info('Waiver removed.');
                }
                else {
                    this.toastr.error('Cannot remove waiver. Please contact support');
                    waiverWithNotes = null;
                }
                this.Close(waiverWithNotes);
            });
        };
        this.Close = (waiverWithNotes) => this.close({ $value: waiverWithNotes });
        this.cancel = () => this.dismiss({ $value: this.waiverWithNotes });
        this.toastr = toastr;
        this.UserDetailsApi = UserDetailsApi;
        this.WaiverServiceApi = WaiverServiceApi;
        this.moment = moment;
    }
}
angular.module('app').component('waiverModal', {
    bindings: {
        resolve: '<', // IWaiverModalResolve
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/TraceDetails/Waiver/waiver-modal.tpl.html',
    controllerAs: 'vm',
    controller: WaiverModalController
});
